module.exports = __webpack_public_path__ + "static/media/Group 26@1.5x.85018b5a.svg";